<template>
  <div>
    <v-dialog v-if="item"  width="70%" :value="overlay">
      <v-card elevation="10">
        <v-card-title>
          {{$t('state.change')}}
        </v-card-title>
        <PopupStateGeneral
            ref="updateFormGeneral"
            v-if="item"
            :values="item"
            :errors="violations"
            :commentPlaceholder="placeholderComment"
        />
        <div v-if="item.state">

          <div v-if="item.state.specialToPrint">
            <v-card-title>
              {{$t('state.fillAttributes')}}
            </v-card-title>
            <PopupStateToPrint
                ref="updateForm"
                v-if="item"
                :values="item"
                :errors="violations"
            />
          </div>

          <div v-if="item.state.specialDoable">
            <v-card-title>
              {{$t('state.fillAttributes')}}
            </v-card-title>
            <PopupStateFaisable
                ref="updateForm"
                v-if="item"
                :values="item"
                :errors="violations"
            />
          </div>

          <div v-if="item.state.specialOrdered">
            <v-card-title>
              {{$t('state.fillAttributes')}}
            </v-card-title>
            <PopupStateOrdered
                ref="updateForm"
                v-if="item"
                :values="item"
                :errors="violations"
            />
          </div>

          <div v-if="item.state.specialPrinted">
            <v-card-title>
              {{$t('state.fillAttributes')}}
            </v-card-title>
            <PopupStatePrinted
                ref="updateForm"
                v-if="item"
                :values="item"
                :errors="violations"
            />
          </div>
        </div>
        <v-btn class="mx-4" color="primary" @click="popup">{{$t('global.submit')}} </v-btn>
        <v-btn class="mx-4 my-3" color="secondary" @click="$emit('close-popup')">{{ $t('global.close') }}</v-btn>

      </v-card>
    </v-dialog>
    <Loading :visible="isLoading || deleteLoading" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import UpdateMixin from '../../mixins/UpdateMixin';
import PopupStateFaisable from "@/components/orderstate/popupFaisable.vue";
import PopupStatePrinted from "@/components/orderstate/popupPrinted.vue";
import PopupStateToPrint from "@/components/orderstate/popupToPrint.vue";
import PopupStateOrdered from "@/components/orderstate/popupOrdered.vue";
import PopupStateGeneral from "@/components/orderstate/popupGeneral.vue";

const servicePrefix = 'Order';

export default {
  name: 'UpdatePopup',
  servicePrefix,
  mixins: [UpdateMixin],
  props: {
    overlay: {
      type: Boolean,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    PopupStateGeneral,
    Loading,
    PopupStateToPrint,
    PopupStateOrdered,
    PopupStateFaisable,
    PopupStatePrinted,
  },
  data() {
    return {
      item: {
      },
      content: null,
      placeholdersBySpecial: {
        specialPrinted: [
          "Nombre d'impressions lancés ",
          "Nombre d'impressions achevés ",
          "Motifs d'échec d'impression"
        ],
        specialOrdered: [
          "Aménagement de la pièce"
        ]
      }
    };
  },

  computed: {
    ...mapFields('order', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations',
    }),
    ...mapGetters('order', ['find']),
    placeholderComment() {
      if (!this.item.state) return '';
      for (const key in this.placeholdersBySpecial) {
        if (this.item.state[key]) {
          return this.placeholdersBySpecial[key];
        }
      }
      return '';
    }
  },

  methods: {
    popup() {
      this.onSendForm();

    },
    onSendForm() {
      let object = {};
      let updateForm;
      if (this.$refs['updateForm']) {
        updateForm = this.$refs.updateForm;
        this.$refs.updateFormGeneral.$v.$touch();
      } else {
        updateForm = this.$refs.updateFormGeneral;
      }
      updateForm.$v.$touch();

      if (!updateForm.$v.$invalid && !this.$refs.updateFormGeneral.$v.$invalid) {
        let objectAll;
        object['@id'] = this.item['@id'];
        object['state'] = this.item.state;
        object['commentTampon'] = this.item.commentTampon;

        objectAll = updateForm.$v.item.$model;

        if (this.item.state.specialOrdered) {
          object['ref'] = objectAll['ref'];
          object['price'] = objectAll['price'];
          object['resolution'] = objectAll['resolution'];
          object['quantity'] = objectAll['quantity'];
          object['quotation'] = objectAll['quotation'];
          if(objectAll['deliveryObjectif']!=null || objectAll['deliveryObjectif']!=undefined)
            object['deliveryObjectif'] = objectAll['deliveryObjectif'];
        }
        if (this.item.state.specialToPrint) {
          object['operator'] = objectAll['operator'];
          object['delivery'] = objectAll['delivery'];
          object['priority'] = objectAll['priority'];
        }
        if (this.item.state.specialDoable) {
          object['risk'] = objectAll['risk'];
          object['cost'] = objectAll['cost'];
          object['material'] = objectAll['material'];
        }
        if (this.item.state.specialPrinted) {
          object['failedItems'] = objectAll['failedItems'];
          object['prodfile'] = objectAll['prodfile'];
        }
        this.$emit('close-popup');
        // Correction bug : data combobox null -> ne met pas à 0 l'object
        Object.keys(object).forEach(function (key) {
          if (object[key] == undefined) {
            object[key] = null;
          }
        });
        this.update(object);
      }
    },
    ...mapActions('order', {
      update: 'update',
      deleteItem: 'del',
      retrieve: 'load',
    }),

  },

};
</script>